<template>
    <div class="acomodar">
        <RegistroCeseMasivo/>
    </div>
</template>

<script>
import RegistroCeseMasivo from '@/components/ModContratos/RegistroCese/RegCesMasivo.vue'
export default {
    name: 'SolimanologRegistroDeCeseMasivo',
    components:{
        RegistroCeseMasivo
    },
    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style  scoped>
.acomodar {
    box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  margin-right: 0.5rem !important;
  margin-top: 9px;
  margin-bottom: 9px;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y:hidden;
}
</style>